import type { CityConfig } from "../city-template/types";

export const laramieConfig: CityConfig = {
  city: "Laramie",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "laramie",
  route: "/cities/laramie",
  title: "Emergency Passport Laramie, WY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Laramie, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Laramie, University of Wyoming, Albany County, and southeastern Wyoming travelers. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Laramie, WY",
  heroSubtitle: "UW study abroad deadline looming? Faculty researcher heading to an international conference? Albany County ranch family planning a trip abroad? We help Laramie residents — from UW international students to Snowy Range outdoor guides to downtown small business owners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Laramie%20Wyoming%20with%20the%20historic%20University%20of%20Wyoming%20campus%20featuring%20the%20distinctive%20sandstone%20Prexys%20Pasture%20and%20Old%20Main%20building%20against%20the%20backdrop%20of%20the%20Snowy%20Range%20mountains%2C%20wide%20open%20prairie%20with%20big%20Wyoming%20sky%20at%20golden%20hour%2C%20western%20college%20town%20atmosphere%2C%20crisp%20high-altitude%20light%2C%20editorial%20travel%20photography&width=1800&height=700&seq=laramie-hero-2026&orientation=landscape",
  heroImageAlt: "Laramie Wyoming with University of Wyoming campus and Snowy Range mountains at golden hour",
  geoPosition: "41.3114;-105.5911",
  geoPlacename: "Laramie, Wyoming",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 150 miles from Laramie via I-25 and US-287; a 2.5 hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Laramie", zips: "82070, 82072, 82073" },
    { name: "Centennial", zips: "82055" },
    { name: "Bosler", zips: "82051" },
    { name: "Rock River", zips: "82083" },
    { name: "Woods Landing", zips: "82063" },
    { name: "Jelm", zips: "82063" },
    { name: "Cheyenne", zips: "82001" },
    { name: "Fort Collins, CO", zips: "80521" },
  ],
  benefits: [
    { icon: "ri-school-line", title: "University of Wyoming International Travel Expertise", desc: "UW sends hundreds of students abroad each year and hosts international students from over 90 countries. We understand the academic calendar, study abroad deadlines, and F-1/J-1 visa passport requirements that UW students and faculty face." },
    { icon: "ri-flight-takeoff-line", title: "LAR — Laramie Regional Airport & DIA Connections", desc: "Laramie Regional Airport connects to Denver International Airport via United Express. DIA is a major international gateway 150 miles south. We coordinate passport timelines around your LAR connection to DIA and beyond." },
    { icon: "ri-building-2-line", title: "Denver Agency — 150 Miles, Still a Burden", desc: "While Denver is the closest regional agency at 150 miles, a same-day appointment means a 5+ hour round trip drive. For UW students, faculty, and Albany County families, our courier service eliminates that drive entirely." },
    { icon: "ri-home-2-line", title: "College Town + Ranching Community Dual Focus", desc: "Laramie uniquely combines academic international travel needs with Albany County ranching families heading abroad. We serve both communities with equal expertise — from student visas to ranch exchange programs." },
  ],
  internalLinks: [
    { name: "Expedited passport in Cheyenne, WY", route: "/cities/cheyenne" },
    { name: "Fast passport services in Casper, WY", route: "/cities/casper" },
    { name: "Quick passport in Fort Collins, CO area", route: "/fort-collins" },
    { name: "Urgent passport services in Denver, CO", route: "/denver" },
    { name: "Wyoming passport services overview", route: "/cities/wyoming-state" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Laramie via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 2.5+ hours to Colorado. Laramie residents can ship from any UPS Store, FedEx Office, or post office location across Albany County.",
  fpcOfficeDistance: "Serving Laramie, Centennial, Bosler, Rock River, Woods Landing, Jelm, and all Albany County and southeastern Wyoming communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Laramie and Albany County. From the University of Wyoming campus to the historic downtown district along Grand Avenue, from the Snowy Range foothills to the Laramie Plains ranches — we serve all of southeastern Wyoming. Our courier service eliminates the need to drive to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Laramie and all Albany County communities including Centennial, Bosler, and Rock River. We also serve UW international students, faculty researchers, and Albany County ranch families planning international travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Laramie as simple as possible — with the reliability UW faculty, Albany County ranchers, and Laramie families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Laramie travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Laramie travelers encounter unique passport issues — from UW study abroad documentation deadlines to Albany County rural address verification to international student visa coordination. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Southeastern Wyoming travelers — from UW study abroad students to Snowy Range outdoor guides to Albany County ranch families — trust us when their international departure is days away and a Denver drive is not practical.",
  faqIntro: "Have questions about expedited passports in Laramie, WY? Here are the most common ones we hear from UW travelers and Albany County residents.",
  statePageRoute: "/cities/wyoming-state",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before a UW study abroad semester, an emergency passport for a last-minute LAR connection to DIA, or a first-time passport for an Albany County family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for UW study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned academic travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Laramie", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 150 miles from Laramie", "5+ hour round trip — impractical for most Albany County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "LAR flight connecting to an international DIA departure in 2 days? Study abroad orientation starts Monday? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Laramie travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Laramie residents renew fast — no agency visit required for most renewals. Perfect for UW faculty heading to conferences and Albany County families traveling abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Albany County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your UW research trip or family vacation is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Albany County family trip abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Laramie area residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for UW researchers with overlapping conference schedules and Albany County business owners with international clients.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Albany County travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Laramie residents making quick trips across the border.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Laramie WY", description: "Urgent passport processing for Laramie Wyoming travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Laramie WY", description: "Fast passport renewal for Laramie Wyoming residents with a previously-issued passport." },
    { name: "First-Time Passport Laramie WY", description: "New passport application services for Laramie Wyoming residents applying for their first passport." },
    { name: "Child Passport Laramie WY", description: "Minor passport services for Laramie Wyoming families with children under 16." },
    { name: "Name Change Passport Laramie WY", description: "Passport name correction after marriage, divorce, or legal name changes for Laramie residents." },
    { name: "Second Passport Laramie WY", description: "Second passport services for Laramie frequent travelers and UW academic professionals." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Laramie",
      rating: 5,
      text: "I'm a UW grad student and my study abroad program to Norway had a paperwork issue — my passport was expiring sooner than I realized. Fast Passport Center got it renewed in 4 days. I made my flight. The alternative was driving to Denver and missing orientation.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. James T.",
      location: "Laramie",
      rating: 5,
      text: "UW faculty presenting at a conference in Zurich. Realized two weeks before that my passport had less than 3 months validity. They expedited a renewal and I had it in hand 6 days later. Outstanding service for academic professionals who can't afford to lose travel days.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "Albany County",
      rating: 5,
      text: "Our ranch family planned a trip to Argentina for an agricultural exchange. Three of us needed new passports. Fast Passport Center walked us through everything, caught a photo issue, and got all three passports back in time. Saved us from driving to Denver.",
      service: "New Passports — Family",
    },
    {
      name: "Chen W.",
      location: "Laramie",
      rating: 5,
      text: "International student at UW — my passport was expiring and I needed to travel home for a family emergency. Fast Passport Center understood the urgency and my specific situation. They expedited my renewal so I could get home. Incredibly grateful.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "laramie-1",
      name: "Laramie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "204 S Adams St",
      city: "Laramie",
      state: "WY",
      zip: "82070",
      phone: "(307) 745-4701",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Laramie",
      website: "https://tools.usps.com/find-location.htm?location=1375101",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Albany County. Appointment availability fills quickly during UW semester starts and breaks — schedule at least a week ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "laramie-2",
      name: "University of Wyoming — Passport Acceptance Office",
      type: "Campus Passport Acceptance",
      address: "1000 E University Ave, Wyoming Union Room 012",
      city: "Laramie",
      state: "WY",
      zip: "82071",
      phone: "(307) 766-4120",
      hours: "Mon–Fri 10:00 AM – 3:00 PM (during academic sessions)",
      distance: "UW Campus — Central Laramie",
      website: "https://www.uwyo.edu/",
      websiteLabel: "UW Website",
      notes: "Convenient on-campus option for UW students, faculty, and staff. Limited hours during summer and winter breaks. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "laramie-3",
      name: "Albany County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "525 E Grand Ave, Room 301",
      city: "Laramie",
      state: "WY",
      zip: "82070",
      phone: "(307) 721-2514",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Laramie — Albany County Courthouse",
      website: "https://www.albanycountywy.gov/",
      websiteLabel: "Albany County Website",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "laramie-4",
      name: "Cheyenne Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4800 Converse Ave",
      city: "Cheyenne",
      state: "WY",
      zip: "82009",
      phone: "(307) 772-2057",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Cheyenne — about 50 miles east of Laramie via I-80",
      website: "https://tools.usps.com/find-location.htm?location=1364907",
      websiteLabel: "USPS Location",
      notes: "Larger facility with more appointment availability. About 50 minutes from Laramie — good backup when Laramie facilities are fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "laramie-5",
      name: "Fort Collins Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 E Boardwalk Dr",
      city: "Fort Collins",
      state: "CO",
      zip: "80525",
      phone: "(970) 226-0693",
      hours: "Mon–Fri 8:00 AM – 5:00 PM (appointment required)",
      distance: "Fort Collins, CO — about 70 miles south of Laramie via US-287",
      website: "https://tools.usps.com/find-location.htm?location=1352447",
      websiteLabel: "USPS Location",
      notes: "Large Colorado facility with frequent appointment availability. Useful for Laramie residents already heading south to Denver or DIA.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 150 miles and 2.5+ hour drive from Laramie one way", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO near Denver; 5+ hour round trip for Laramie residents", fpc: "Most Laramie travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, especially problematic for students and first-time applicants", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Laramie Residents", agency: "5+ hour round trip to Denver — difficult for students, faculty, and families", fpc: "Entirely remote — forms online, ship from Laramie, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off classes or work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Academic Context", agency: "No UW-specific guidance — no understanding of study abroad, international student, or academic conference needs", fpc: "Full UW and Albany County knowledge — academic calendar, student visas, international research travel patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "UW Study Abroad Deadline Miscalculations",
      description: "UW students often book flights the moment they receive study abroad acceptance — but forget to check their passport expiration. A passport with less than 6 months validity may block entry to many countries. Check your passport before accepting a study abroad placement.",
    },
    {
      icon: "ri-error-warning-line",
      title: "International Student Passport & Visa Timing Conflicts",
      description: "F-1 and J-1 visa holders at UW sometimes need to renew their home country passport while also needing their U.S. visa valid for re-entry. This dual-timeline coordination is critical — start the passport renewal process well before your visa expiration.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Albany County Rural Address Documentation",
      description: "Rural Albany County addresses (ranch route numbers, PO boxes) can cause application delays when they differ from residential addresses on supporting documents. We review all documentation to catch address mismatches.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Issues from Campus Services",
      description: "On-campus photo services at UW may produce photos with shadows, incorrect sizing, or backgrounds that don't meet strict State Department standards. We catch these issues in review before they cause a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Denver Is Convenient Due to Relative Proximity",
      description: "At 150 miles, Denver is the closest passport agency to Laramie — closer than most Wyoming cities. But a same-day agency appointment still requires a 5+ hour round trip. Our courier channel is faster and more practical even at this distance.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether an academic conference, study abroad departure, or family vacation." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — student, faculty, rancher, or Laramie family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Laramie clients ship from the UPS Store on Grand Avenue or the Laramie Post Office on Adams Street." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Albany County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Laramie, Centennial, or Albany County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Laramie, Wyoming?", a: "We offer Laramie-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (150 miles away) — our remote courier service eliminates the need for that 5+ hour round trip." },
    { q: "Do I need to visit a Laramie office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Laramie Post Office, UW Passport Office, or Albany County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Albany County address." },
    { q: "Where can I get a passport acceptance near Laramie?", a: "Laramie has acceptance facilities at the Main Post Office on Adams Street, the UW Wyoming Union, and the Albany County Clerk of District Court. Nearby options include the Cheyenne Main Post Office and Fort Collins facilities in Colorado. We maintain an updated list with hours and appointment requirements." },
    { q: "I'm a UW student — can you help with study abroad passport needs?", a: "Yes. UW students are among our most frequent clients. Whether you are heading out on a semester abroad, need a renewal before an international program starts, or are an international student needing passport services, we provide fast expedited processing tailored around the academic calendar." },
    { q: "What if I need a passport and Denver is too far?", a: "Even though Denver is only 150 miles from Laramie — the closest Wyoming city to a passport agency — the round trip still takes 5+ hours. For students with classes, faculty with teaching schedules, and families with limited time, our registered courier service is the most practical expedited option." },
    { q: "What is the best price for expedited passport service in Laramie?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Laramie applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide an Albany County-specific checklist." },
    { q: "Can I get a passport photo in Laramie?", a: "Yes. The Laramie Post Office, CVS on Grand Avenue, and the UPS Store on Grand Avenue all offer passport photo services. UW campus services also provide photos during the academic year. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does LAR airport connect to international flights?", a: "Laramie Regional Airport (LAR) connects to Denver International Airport (DIA) via United Express. DIA offers direct international flights to Europe, Asia, and Latin America. Your passport must be valid when you check in at LAR, as you are ticketed through to your international destination." },
    { q: "Can you help with passports for UW international students?", a: "Yes. International students on F-1 or J-1 visas often need passport renewals from their home country while maintaining valid U.S. status. We help coordinate the timing and provide fast expedited processing to minimize disruption to your studies." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Laramie Residents",
    intro: "Laramie's position on I-80, between the Snowy Range and the Laramie Plains, and home to Wyoming's only four-year university creates unique passport timing considerations. Here's what Albany County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "LAR — Laramie Regional Airport to DIA",
        subtitle: "The crucial first leg for most Laramie international travelers",
        description: "LAR connects to Denver International Airport (DIA) via United Express turboprop service. From DIA, travelers access direct flights to London, Frankfurt, Tokyo, and across Latin America. The key timing insight: your passport is checked at LAR check-in, not at DIA. If your passport won't be valid, you won't board in Laramie.",
        tip: "Check your passport expiration the moment you book any itinerary departing from LAR — even if your international flight is days later from DIA. A passport issue at Laramie check-in can unravel the entire trip.",
      },
      {
        icon: "ri-school-line",
        title: "UW Academic Calendar & International Travel",
        subtitle: "Semester-driven travel patterns for students and faculty",
        description: "UW's academic calendar creates predictable travel surges: late May for summer study abroad, early August for fall semester international student arrivals, late December for winter break travel, and January for spring semester abroad. Bookmark these seasonal windows and check your passport 3-4 months ahead.",
        tip: "Study abroad students should begin the passport process the semester before departure. Faculty with sabbatical or conference travel should check passport validity when submitting abstract proposals, not when booking flights.",
      },
      {
        icon: "ri-road-map-line",
        title: "I-80 Corridor & Southern Wyoming Travel",
        subtitle: "The transcontinental highway shapes Laramie travel patterns",
        description: "I-80 connects Laramie to Cheyenne (50 miles east), Salt Lake City (380 miles west), and Denver (150 miles south via US-287 and I-25). This corridor means Laramie travelers can access multiple major airports: DIA for international departures, SLC for Asia-Pacific connections, and regional airports for domestic feeder flights.",
        tip: "For international travel with complex itineraries — like connecting from LAR to DIA to a European destination — build in at least one extra day of buffer in case of high plains weather disrupting the LAR connection.",
      },
      {
        icon: "ri-home-2-line",
        title: "Albany County Ranching & Agricultural Exchange",
        subtitle: "International agricultural programs and ranch exchange travel",
        description: "Albany County's ranching community participates in international agricultural exchanges, livestock shows, and ranch management programs in Argentina, Australia, New Zealand, and Canada. These trips are often scheduled around the agricultural calendar with specific seasonal windows. Passport readiness is critical for these fixed-date opportunities.",
        tip: "Agricultural exchange programs and international livestock events have strict application deadlines. Begin your passport renewal process at least 8 weeks before any international ranch or agricultural program application deadline.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Laramie & the High Plains Corridor",
      description: "Laramie sits at 7,165 feet elevation on the Laramie Plains between the Snowy Range and the Laramie Range — the highest elevation college town in America with a four-year university. The city's position on I-80, the Lincoln Highway, and the historic Overland Trail makes it a crossroads between the Intermountain West and the Great Plains. UW draws students from all 50 states and over 90 countries, making Laramie one of Wyoming's most internationally connected communities.",
    },
  },
  destinations: {
    title: "Where Laramie Travelers Go — And Why Passports Get Urgent",
    intro: "Laramie's identity as a university town on the I-80 corridor shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "40%", label: "of Laramie expedited requests involve UW-related academic travel" },
      { stat: "2–3 Weeks", label: "average lead time from trip confirmation to departure for Laramie travelers" },
      { stat: "Aug & Jan", label: "peak months for study abroad and international student travel" },
      { stat: "150 Miles", label: "to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Europe", context: "UW study abroad programs in UK, France, Germany, Spain, Norway, and Italy; faculty research and conference presentations; family heritage travel", urgency: "Study abroad acceptance letters with 4–8 week departure lead time", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Banff and Canadian Rockies recreation, Calgary and Edmonton connections, agricultural conferences and ranch exchanges in Alberta and Saskatchewan", urgency: "Recreational and professional travel with flexible but seasonal timing", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "UW engineering and science research partnerships in Japan, China, South Korea; international student travel home; academic exchanges", urgency: "Research deadlines and conference dates with fixed schedules", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Argentina and Brazil agricultural exchanges, Chile adventure travel, Peru research trips, Patagonia expeditions", urgency: "Southern Hemisphere summer (November–February) ranch and agriculture programs", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Working holiday visas for UW graduates, agricultural internships, adventure travel", urgency: "Post-graduation travel with short turnaround between finals and departure", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter break getaways, UW spring break service trips, language immersion programs", urgency: "Academic break travel with fixed dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Cheyenne", route: "/cities/cheyenne" },
      { name: "Casper", route: "/cities/casper" },
      { name: "Fort Collins, CO", route: "/fort-collins" },
    ],
  },
  photoLocations: [
    { name: "Laramie Main Post Office", address: "204 S Adams St, Laramie, WY 82070", hours: "Mon–Fri 9 AM – 4 PM (limited photo service)" },
    { name: "CVS Pharmacy — Laramie", address: "1945 E Grand Ave, Laramie, WY 82070", hours: "Daily 8 AM – 9 PM" },
    { name: "The UPS Store — Laramie", address: "252 N 3rd St, Laramie, WY 82072", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 3 PM" },
    { name: "Walmart Supercenter — Laramie", address: "4308 E Grand Ave, Laramie, WY 82070", hours: "Daily 6 AM – 11 PM" },
    { name: "UW Campus Photo Services", address: "Wyoming Union, 1000 E University Ave, Laramie, WY 82071", hours: "Mon–Fri 10 AM – 3 PM (academic sessions only)" },
    { name: "Walgreens — Cheyenne", address: "2304 E Lincolnway, Cheyenne, WY 82001", hours: "Daily 8 AM – 10 PM (50 miles from Laramie)" },
  ],
  dmvLocations: [
    {
      name: "Albany County Treasurer — Motor Vehicle Division",
      address: "525 E Grand Ave, Suite 106, Laramie, WY 82070",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "WyDOT Driver Services — Cheyenne",
      address: "5300 Bishop Blvd, Cheyenne, WY 82009",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full driver services including testing and REAL ID. About 50 miles from Laramie.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LAR",
      name: "Laramie Regional Airport",
      distance: "About 5 miles west of downtown Laramie (10 minutes via I-80)",
      address: "555 N General Brees Rd, Laramie, WY 82072",
      note: "Connects to Denver International Airport (DIA) via United Express. The crucial first leg for most Laramie international travelers. Free parking makes it an easy departure point.",
      flightUrl: "https://www.laramieairport.com/",
      flightLabel: "Laramie Airport Website",
      featured: true,
    },
    {
      code: "DIA",
      name: "Denver International Airport",
      distance: "About 150 miles south of Laramie (2.5 hour drive via US-287 and I-25)",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Major international gateway with direct flights to Europe, Asia, and Latin America. Accessible from Laramie via LAR connection or direct drive. The primary international departure point for Albany County travelers.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "Denver Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services. Online, mail, or in-person options available.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services. Required for estate and legal matters in Albany County.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Albany County Clerk of District Court. Certified copies available for name changes and passport applications.",
      url: "https://www.albanycountywy.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Albany County District Court. Required for name change passport corrections.",
      url: "https://www.albanycountywy.gov/",
    },
  ],
};